/* eslint-disable no-underscore-dangle */
import React, { FC, useEffect } from 'react';

import { isBrowser } from '@lucid/utils';

import Box from '../box/box';

export interface WistiaChannelProps {
  /** The hashed ID from Wistia. */
  hashedId: string;
  /** The Wistia options. */
  embedOptions?: {};
}

const WistiaChannel: FC<WistiaChannelProps> = ({ hashedId, embedOptions }) => {
  if (isBrowser()) {
    window._wq = window._wq || [];
    window._wq.push({
      id: hashedId,
      options: embedOptions
    });
  }

  useEffect(() => {
    if (!document.getElementById('wistia_script')) {
      const wistiaScript = document.createElement('script');
      wistiaScript.id = 'wistia_script';
      wistiaScript.type = 'text/javascript';
      wistiaScript.src = 'https://fast.wistia.net/assets/external/channel.js';
      wistiaScript.async = true;
      document.body.appendChild(wistiaScript);
    }
  });

  // for some reason the clsx package does not work here
  // so we are just adding them all a bit more manually
  const classAttributes = [
    'wistia_channel',
    `wistia_async_${hashedId}`,
    'mode=inline',
    'customFont=Graphik',
    'backgroundColor=ffffff',
    'foregroundColor=282C33',
    'resumable=false',
    'videoCardsLayout=grid',
  ];

  return (
    <Box margin="auto" maxWidth="1200px">
      <Box className={classAttributes.join(' ')} />
    </Box>
  );
};

export default WistiaChannel;
